import React from 'react';
import { FuelButton } from '@frete.com/fuel-react';
import svgListingError from '@assets/illustrations/listing-error.svg';
import * as Styled from './ErrorStyles';

interface ErrorProps {
  onClick(): void;
}

function Error({ onClick }: ErrorProps) {
  return (
    <Styled.Container>
      <Styled.Img src={svgListingError} alt="" />
      <Styled.Title>Algo deu errado</Styled.Title>
      <Styled.Description>
        Não foi possível carregar suas viagens. Estamos trabalhando para voltar
        ao normal.
      </Styled.Description>
      <Styled.WrapperActions>
        <FuelButton
          variant="primary"
          size="large"
          trailingIcon="update"
          onClick={() => onClick()}
          fullWidth
        >
          Tentar novamente
        </FuelButton>
      </Styled.WrapperActions>
    </Styled.Container>
  );
}

export default Error;
